import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40ef3923"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "slide-container" }
const _hoisted_2 = { class: "slide-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Which Area would you like to see?", -1))
const _hoisted_4 = { class: "input-container" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("SVP Area")
const _hoisted_6 = { class: "input-container" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("CVP Area")
const _hoisted_8 = { class: "input-container" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("VP Area")
const _hoisted_10 = { class: "slide-bottom-navigation" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Continue")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_button = _resolveComponent("ion-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_ion_label, null, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_ion_select, {
          modelValue: _ctx.areaFilterModel.svp.selected,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.areaFilterModel.svp.selected) = $event)),
          placeholder: _ctx.areaFilterModel.svp.items.length ? 'Choose one or multiple options' : 'No options available',
          disabled: !_ctx.areaFilterModel.svp.items.length,
          multiple: "true",
          interface: "alert",
          "interface-options": { cssClass: 'onboarding-ion-alert-css' }
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.areaFilterModel.svp.items, (item) => {
              return (_openBlock(), _createBlock(_component_ion_select_option, {
                value: item.value,
                key: item.key
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.text), 1)
                ]),
                _: 2
              }, 1032, ["value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_ion_label, null, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_component_ion_select, {
          modelValue: _ctx.areaFilterModel.cvp.selected,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.areaFilterModel.cvp.selected) = $event)),
          placeholder: _ctx.areaFilterModel.cvp.items.length ? 'Choose one or multiple options' : 'No options available',
          disabled: !_ctx.areaFilterModel.cvp.items.length,
          multiple: "true",
          interface: "alert",
          "interface-options": { cssClass: 'onboarding-ion-alert-css' }
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.areaFilterModel.cvp.items, (item) => {
              return (_openBlock(), _createBlock(_component_ion_select_option, {
                value: item.value,
                key: item.key
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.text), 1)
                ]),
                _: 2
              }, 1032, ["value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_ion_label, null, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }),
        _createVNode(_component_ion_select, {
          modelValue: _ctx.areaFilterModel.vp.selected,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.areaFilterModel.vp.selected) = $event)),
          placeholder: _ctx.areaFilterModel.vp.items.length ? 'Choose one or multiple options' : 'No options available',
          disabled: !_ctx.areaFilterModel.vp.items.length,
          multiple: "true",
          interface: "alert",
          "interface-options": { cssClass: 'onboarding-ion-alert-css' }
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.areaFilterModel.vp.items, (item) => {
              return (_openBlock(), _createBlock(_component_ion_select_option, {
                value: item.value,
                key: item.key
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.text), 1)
                ]),
                _: 2
              }, 1032, ["value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder", "disabled"])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_ion_button, {
        expand: "block",
        onClick: _ctx.slideContinue
      }, {
        default: _withCtx(() => [
          _hoisted_11
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}